import { Link, LinkProps } from 'react-router-dom';
import * as React from 'react';
import { useContext } from 'react';
import { TenantContext } from '../../context/tenant-context';

export const QuipliLink = (
  props: LinkProps & React.RefAttributes<HTMLAnchorElement> & { ecommerceLink?: boolean; v2Link?: boolean },
) => {
  const { contextPath, spaMode } = useContext(TenantContext);

  const isContainedInIframe = window.location !== window.parent.location;
  const isLegacyAppLink = isContainedInIframe && (props.v2Link !== undefined ? !props.v2Link : true);

  const contextPathUrl = contextPath && !contextPath.includes('legacy-app') ? contextPath : '/';

  const href = !props.ecommerceLink
    ? spaMode
      ? `${contextPathUrl}manager/${props.to.toString()}`
      : `${contextPathUrl}${isLegacyAppLink ? 'legacy-app/' : ''}manager/${props.to.toString()}`
    : `${contextPathUrl}${props.to.toString()}`;

  return spaMode ? (
    <Link {...props} to={href} />
  ) : (
    <a
      {...props}
      href={href}
      onClick={(e) => {
        isLegacyAppLink && e.preventDefault();
      }}
    ></a>
  );
};
